import { LeagueConfig } from '@leagueplatform/config';
import { AppTenant } from 'types';
import {
  highmarkCommonCoreConfig,
  highmarkConfigFlags,
} from './highmark-theme/config/highmark-common-config';
import { ASSETS_CONFIG } from './highmark-theme/config/iel-asset-config';
import { CS_AUTH0_CLIENT_CONNECTION } from './contants';

const {
  VITE_HIGHMARK_IEL_AUTH0_DOMAIN,
  VITE_HIGHMARK_IEL_AUTH0_CLIENT_ID,
  VITE_HIGHMARK_IEL_CONTENT_URL,
} = import.meta.env;

export const highmarkIEL = {
  core: {
    ...highmarkCommonCoreConfig,
    tenantId: AppTenant.HighmarkIel,
    clientId: `${AppTenant.HighmarkIel}-web`,
    auth: {
      clientOptions: {
        domain: VITE_HIGHMARK_IEL_AUTH0_DOMAIN,
        client_id: VITE_HIGHMARK_IEL_AUTH0_CLIENT_ID,
        redirect_uri: window.location.origin,
        connection: CS_AUTH0_CLIENT_CONNECTION,
      },
      idleSessionLifetimeHours: 0.25,
    },
    contentUrl: VITE_HIGHMARK_IEL_CONTENT_URL,
  },
  assets: {
    overrides: ASSETS_CONFIG,
  },
  customerSupport: {
    ...highmarkConfigFlags.customerSupport,
    impersonation: {
      enableImpersonateButton: true,
      impersonationFeedbackUrl: 'https://forms.gle/WE2zzZnV2xjSLZJ96',
      onImpersonationStart: async (loginId: string, ecid: string) => {
        const appName = 'MyHighmark';

        const endpoint = `https://securetenv7.highmark.com/emssvc/websecure/secure/sso/outbound/auto/v1/vendor/LEAGUESUPPORT?memberLoginID=${loginId}&memberECID=${ecid}&Tool=${appName}&session_type=impersonation`;

        try {
          const res = await fetch(endpoint, {
            method: 'POST',
            redirect: 'manual',
          });

          if (res.url) {
            window.open(res.url);
          }
        } catch (error) {
          console.log('errorerror', error);
        }
      },
    },
  },
} satisfies LeagueConfig;
